import { useStore } from "vuex";
import { ref, reactive, computed, onBeforeMount } from "vue";
import { promoteUrl } from "@/utils/url";
export default {
  name: "PalcodeSuccessPopup",
  setup() {
    const store = useStore();
    const state = reactive({
      isGetData: false
    });

    // ------------------------------------------------------------------
    // 福米奖励
    const palcodeBonus = computed(() => store.getters['user/palcodeBonus']);
    onBeforeMount(async () => {
      if (!palcodeBonus.value.recommendedBy) {
        // 预设是空字串
        await store.dispatch('user/getTaskList');
      }
      state.isGetData = true;
    });

    // ------------------------------------------------------------------
    // 关闭弹窗
    const close = () => {
      parent.postMessage({
        vueIframe: {
          elemtId: 'i-recommend',
          action: 'close'
        }
      });
      store.dispatch('common/showPalcodeSuccessPopup', {
        show: false
      });
    };

    // ------------------------------------------------------------------
    // 其他任务
    function linkToTaskList() {
      const isInIframe = window.frameElement;
      if (isInIframe) {
        parent.postMessage({
          vueIframe: {
            elemtId: 'i-recommend',
            action: 'mission'
          }
        });
      } else {
        // 因为怕有延迟，所以添加 loading 来防呆
        store.dispatch("common/handleLoading", true);
        store.dispatch("common/closeRedirectLoadingInterval");
        location.href = promoteUrl() + '/plugin.php?id=jyjbwl:mission';
      }
    }
    return {
      state,
      palcodeBonus,
      close,
      linkToTaskList
    };
  }
};